export default "__VITE_ASSET__DLDvJztC__"